import { canonicalize } from "./Parsing";

export function normalizeToKnownDrivers(names: string[], allDrivers: string[]) {
  const byCanon = new Map(allDrivers.map((n) => [canonicalize(n), n]));
  const normalized: string[] = [];
  names.forEach((n) => {
    const mapped = byCanon.get(canonicalize(n));
    if (mapped) normalized.push(mapped);
  });
  return normalized;
}
